// extracted by mini-css-extract-plugin
export default {"imageContainer":"ImagePersonWithPet_imageContainer__w03Xz","centeredImage":"ImagePersonWithPet_centeredImage__omTE-"};